import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  time: string[];
  count?: number[];
}

export const useTasksByHours = (): ChartProps => {
  const { t } = useLang();
  const { list } = useDashboardStore();
  const data = list?.tasks_peaks as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data?.count) {
      const isDataExist = data.count.some((count) => count > 0);

      return {
        series: isDataExist
          ? [
              {
                name: t('Кол-во задач'),
                color: '#962DFF',
                data: data.count,
              },
            ]
          : [],
        options: {
          chart: {
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          stroke: {
            curve: 'smooth',
            colors: ['#962DFF'],
            width: 3,
          },
          xaxis: {
            categories: data.time,
            axisTicks: { show: false },
            tickAmount: 6,
          },
          yaxis: {},
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t]);

  return {
    series: chartData.series,
    options: chartData.options,
    type: 'line',
    label: 'Часовые пики задач',
    subLabel:
      'График помогает определить часы наибольшей активности, упрощая планирование ресурсов и оптимизацию рабочего расписания.',
    wrapped: true,
  };
};
